const config = {
  localStorage: {
    user: "user",
    token: "token",
    basic: "basic",
    business: "business",
    step: "step",
    result: "result",
    reward: "reward",
    claimed: "claimed",
  },
  priceFreezeStatus: {
    initiated: {
      label: "Loan Initiated",
      code: "Initiated",
    },
    approved: {
      label: "Loan Approved",
      code: "Approved",
    },
    declined: {
      label: "Loan Declined",
      code: "Declined",
    },
    cancelled: {
      label: "Loan Cancelled",
      code: "Cancelled",
    },
    completed: {
      label: "Loan Completed",
      code: "Completed",
    },
  },
  loanStatus: {
    pending: {
      code: "PENDING",
      label: "Pending",
    },
    approved: {
      code: "APPROVED",
      label: "Approved",
    },
    rejected: {
      code: "REJECTED",
      label: "Declined",
    },
  },
  repaymentStatus: {
    complete: {
      code: "COMPLETE",
      label: "Completed",
    },
    incomplete: {
      code: "INCOMPLETE",
      label: "Incomplete",
    },
  },
};

export default config;
